let menubar = (function () {
    let overlay = null;
    let visible = false;
    const html = document.querySelector('html');
    const menu = document.querySelector('.js-menubar-nav');

    return {
        open() {
            this.toggleMenu();
            this.showOverlay();
            visible = true;
        },
        close() {
            this.toggleMenu();
            this.hideOverlay();
            visible = false;
        },
        isVisible() {
            return visible;
        },
        toggleMenu() {
            menu.classList.toggle('menubar-nav_visible');
        },
        showOverlay() {
            overlay = document.createElement('div');
            overlay.className = 'menubar-overlay';
            html.style.overflow = 'hidden';
            document.body.appendChild(overlay);
        },
        hideOverlay() {
            html.style.overflow = 'initial';
            document.body.removeChild(overlay);
        }
    }
})();

document.addEventListener('DOMContentLoaded', function () {
    // Toggle mobile menu
    const toggle = document.querySelector('.js-menubar-toggle');

    toggle.addEventListener('click', function () {
        this.classList.toggle('menubar__toggle_opened');
        this.classList.contains('menubar__toggle_opened') ? menubar.open() : menubar.close();
    });

    // mobile menu
    const items = document.querySelectorAll('.js-menubar-list .menu-item-has-children a[href*="#"]');

    for (let item of items) {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            item.parentNode.classList.toggle('menu-item-has-children_active');
        });
    }
});
